import React from 'react';
import Navbar from '../../components/general/Navbar';
import BuildAKeyboard from '../../components/general/BuildAKeyboard';
import Footer from '../../components/general/Footer';

const BuildAKeyboardPage = () => {
  return (
    <>
      <Navbar />
      <BuildAKeyboard />
      <Footer />
    </>
  )
}

export default BuildAKeyboardPage;